function IconCopyPasteData({ fillColor = "none", strokeColor = "currentColor" }) {
  return (
    <svg width="51" height="50" viewBox="0 0 51 50" fill={fillColor} stroke={strokeColor} xmlns="http://www.w3.org/2000/svg">
      <path d="M13.166 26.5625H28.791M13.166 32.8125H28.791M38.166 32.8125H42.8535V7.8125H17.8535V12.5M8.47852 42.1875H33.4785V17.1875H8.47852V42.1875Z" stroke="black" stroke-linejoin="round" />
    </svg>

  )
}

export default IconCopyPasteData;